// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CartLineModel, ProductSubscriptionDto, SectionOptionDto } from "@insite/client-framework/Types/ApiModels";

export interface AddProductApiParameter extends ApiParameter {
    productId: string;
    qtyOrdered: number;
    unitOfMeasure: string;
    notes?: string;
    sectionOptions?: Partial<SectionOptionDto>[];
    subscription?: ProductSubscriptionDto;
    // Store Custom Code
    quoteId: string;
}

const cartsUrl = "/api/v1/carts";

export async function addQuoteWithResult(parameter: AddProductApiParameter): Promise<ServiceResult<CartLineModel>> {
    const cartLine = {
        productId: parameter.productId,
        qtyOrdered: parameter.qtyOrdered,
        unitOfMeasure: parameter.unitOfMeasure,
        notes: parameter.notes,
        sectionOptions: parameter.sectionOptions,
    } as CartLineModel;

    if (parameter.subscription) {
        cartLine.properties = {
            productSubscription: JSON.stringify(parameter.subscription),
        };
    }

    try {
        const cartLineModel = await post(`${cartsUrl}/${parameter.quoteId}/cartlines`, cartLine);
        return {
            successful: true,
            result: cartLineModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error.status === 403) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: 403,
            };
        }
        throw error;
    }
}

export interface AvailabilityByWarehouseParameter {
    productSkus: string[];
}

export async function getAvailabilityByWarehouse(quoteAdditionalInfoParameter: AvailabilityByWarehouseParameter) {
    const apiParameter = {
        additionalQueryStringParameters: quoteAdditionalInfoParameter,
    };

    try {
        const availabilityByWarehouse = await get(`${cartsUrl}/store/getAvailabilityByWarehouse`, apiParameter);
        return {
            successful: true,
            result: availabilityByWarehouse,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error.status === 403) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: 403,
            };
        }
        throw error;
    }
}
